import Vue from 'vue';
import App from './App.vue';
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { VueHammer } from 'vue2-hammer';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import SlideUpDown from 'vue-slide-up-down';

import store from './store.js';
import router from './router.js';

Vue.component('v-select', vSelect);
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);
Vue.component('slide-up-down', SlideUpDown);

Vue.use(VueHammer);
Vue.use(VueReCaptcha, {
  siteKey: '6LcPs4wUAAAAALpe3Nptslki7IrHizofyYMKgnVs'
});

Vue.config.productionTip = false;

VueHammer.config.pan = {
  direction: 'vertical'
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app');
